export default "__VITE_ASSET__CSBv_Jhu__"